<template>
  <drop>
    <drop class="dropzone-area skcc-dropzone" v-show="dropzone1Visible" style="height:360px;" :orderby-index="0" @dragover="onDragOverNode" @drop="onDropNode" @dragleave="onDragLeaveNode">
      <!-- <span class="drop-txt">자원 항목을 선택하고 이곳으로 드래그해주세요</span> -->
    </drop>
    <drop v-for="(chart, index) in chartRscList" :key="chart.orderbyIndex" @dragover="onDragOverNode" @drop="onDropSeries" @dragleave="onDragLeaveNode">
      <w-common-line-chart v-show="chart.visible" :style="getCommonChartStyle(index)" ref="commonLineChart" :added="chart.added" :rsc-info-list="chart.items"
        :orderby-index="chart.orderbyIndex" @mouseOver="onMouseOverChart" @mouseOut="onMouseOutChart" @updateChart="onUpdateChart" onlyMonitoringFlag rawDataFlag
        @clickChart="onClickChart" @deleteChart="onDeleteChart" @setRealtimeChart="setRealtimeChart" chartHeight="360" class="skcc-chart" :extraChartOptions="chartOption"/>
    </drop>
    <drop class="dropzone-area skcc-dropzone" v-show="dropzone2Visible" style="height:360px;" :orderby-index="1" @dragover="onDragOverNode" @drop="onDropNode" @dragleave="onDragLeaveNode">
      <!-- <span class="drop-txt green">자원 항목을 선택하고 이곳으로 드래그해주세요</span> -->
    </drop>
  </drop>
</template>

<script>
import { mapGetters } from 'vuex';
import { Drop } from 'vue-drag-drop';
import { cloneDeep, maxBy, find, remove, clone, isNil } from 'lodash';

import { isEmpty } from '@/utils/basic';
import ChartAnalaysisMixin from '@/mixins/chart/chart-analysis';
import ChartAPI from '@/api/chart/chart-analysis';
import PerformanceAPI from '@/api/performance/analysis/analysis-chart';
import WCommonLineChart from '../../chart/CommonLineChart';

export default {
  name: 'WSkccChartDropZoneView',
  components: {
    Drop,
    WCommonLineChart,
  },
  mixins: [ChartAnalaysisMixin],
  props: {
    dropzoneVisible: Boolean,
    visible: Boolean,
    selectedTreeNode: Object,
    initChart: Object,
  },
  data() {
    return {
      chartRscList: [],
      chartOption: {
        zoomType: 'x',
        resetZoomButton: {
          position: {
            align: 'right',
            x: -20,
            y: -5,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(['analysisDateParams']),
    dropzone1Visible() {
      return (this.dropzoneVisible && this.chartRscList.length === 0);
    },
    dropzone2Visible() {
      return (this.dropzoneVisible && this.chartRscList.length === 1);
    },
  },
  watch: {
    visible(visible) {
      if (!visible) {
        this.chartRscList = [];
      }
    },
    initChart: {
      immediate: true,
      handler(initChart) {
        if (!isNil(initChart.items)) {
          this.chartRscList.splice(0, this.chartRscList.length, initChart);
        } else {
          this.chartRscList = [];
        }

        this.$emit('setChartList', this.chartRscList);
      },
    },
  },
  methods: {
    /**
     * 트리 노드나 자원만 드래그 되도록 UI설정한다.
     * 1. 차트의 최대 개수는 10개이다.
     * 2. 트리 노드는 차트 추가만 가능하다(차트 안에 시리즈 추가는 불가능)
     * 3. 트리 노드의 default 차트와 현재 로드된 차트의 개수 합이 10개 이상이면 트리 노드로 추가 불가능
     * @param  {[type]} node [description]
     * @param  {[type]} e    [description]
     * @return {[type]}      [description]
     * @author jda
     */
    onDragOverNode(node, e) {
      // drop-area gree
      let effect = 'none';
      const className = e.target.className;

      if (!isNil(className) && typeof className.match === 'function') {
        const dropzoneClass = className.match(/blue|green/g);
        if (!isEmpty(dropzoneClass)) {
          effect = 'move';
          e.target.className = className.replace('blue', 'green');
        }
      }

      e.dataTransfer.dropEffect = effect;
    },
    /**
     * 트리 노드나 자원을 드롭할 때 차트가 그려진다.
     * @return {[type]} [description]
     * @author jda
     */
    onDropNode(node, e) {
      // dropSeries의 이벤트가 걸리지 않도록 한다.
      e.stopPropagation();

      const obj = this.selectedTreeNode.obj;
      const dropIndex = e.target.getAttribute('orderby-index');
      const newCharts = [];
      const chartRscList = cloneDeep(this.chartRscList);

      newCharts.push({
        items: [{ objId: obj.objId, managetypeId: obj.objManagetypeId, rsctypeId: node.rsctypeId, rscId: node.rscId, rscKey: isEmpty(node.rscKey) ? '_' : node.rscKey, orderbyIndex: 1 }],
        visible: true,
        added: true,
      });
      this.orderbyChart(chartRscList, dropIndex, newCharts);
    },
    /**
     * 차트 추가시 순서에 맞게 배치한다.
     * @param  {[type]} chartRscList [description]
     * @param  {[type]} dropIndex    [description]
     * @param  {[type]} newCharts    [description]
     * @return {[type]}              [description]
     * @author jda
     */
    orderbyChart(chartRscList, dropIndex, newCharts) {
      chartRscList.splice(dropIndex, 0, ...newCharts);
      for (let i = 0; i < chartRscList.length; i += 1) {
        chartRscList[i].orderbyIndex = i;
      }

      this.chartRscList = chartRscList;
      this.$emit('setChartList', chartRscList);
    },
    /**
     *  rscKey가 없을 경우 DB에서 rscKey를 가져와서 성능 정보 데이터를 가져올 수 있도록 데이터 가공을 해준다.
     * @return {[type]} [description]
     * @author jda
     */
    getRscKeyByRscInfo(data, chartRscList, rscInfo) {
      let rscIdx = data.orderbyIndex;
      const rscKeyInfoList = [];
      ChartAPI.getRscKeyByRscInfo(data).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          result.forEach((rscKey) => {
            const cloneRscInfo = clone(data);
            Object.assign(cloneRscInfo, { rscKey, orderbyIndex: rscIdx });
            rscKeyInfoList.push(cloneRscInfo);

            rscIdx += 1;
          });
          find(chartRscList, { items: rscInfo }).items = rscKeyInfoList;
        }
      });
    },
    /**
     * 트리 노드나 자원을 차트에 드롭할 때 시리즈를 그린다.
     * @return {[type]} [description]
     * @author jda
     */
    onDropSeries(node, e) {
      if (isEmpty(this.chartRscList) || isEmpty(node.rscId)) {
        return;
      }

      const obj = this.selectedTreeNode.obj;
      const rscInfo = { managetypeId: obj.objManagetypeId, rsctypeId: node.rsctypeId, rscId: node.rscId };

      const container = e.target.getElementsByClassName('highcharts-container')[0];
      const dropChart = find(this.chartRscList, (chartObj) => chartObj.chart.container === container);
      const findItem = maxBy(dropChart.items, 'orderbyIndex');

      // E2E일 경우 서비스의 에이전트를 조회하여 차트 시리즈에 추가한다.
      if (node.managetypeId === 'E2E') {
        const rscKey = this.selectedTreeNode.rscKey;

        PerformanceAPI.getE2EAgentListByRscKey({ rscKey }).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            result.forEach((agent) => {
              const items = cloneDeep(rscInfo);
              Object.assign(items, { objId: agent.objId, rscKey, orderbyIndex: findItem.orderbyIndex + 1, added: true });
              dropChart.items.push(items);
            });
            this.$emit('setChartList', this.chartRscList);
          }
        });
      } else {
        Object.assign(rscInfo, { objId: obj.objId, rscKey: isEmpty(node.rscKey) ? '_' : node.rscKey, orderbyIndex: findItem.orderbyIndex + 1, added: true });
        dropChart.items.push(rscInfo);
        this.$emit('setChartList', this.chartRscList);
      }
    },
    /**
     * 차트가 그려진 후 highcharts를 저장한다.
     * @param  {[type]} chart        [description]
     * @param  {[type]} orderbyIndex [description]
     * @param  {[type]} chartItems   [description]
     * @return {[type]}              [description]
     * @author jda
     */
    onUpdateChart(chart, orderbyIndex, chartItems) {
      const findChart = find(this.chartRscList, (record) => record.orderbyIndex === orderbyIndex);
      if (isEmpty(findChart) || isEmpty(chart.series)) {
        return;
      }

      if (!isEmpty(chartItems)) {
        findChart.items = chartItems;
      }
      findChart.chart = chart;
    },
    /**
     * 차트 drop영역에서 다른 drop영역으로 이동했을 때의 퍼블리싱을 적용한다.
     * @param  {[type]} node [description]
     * @param  {[type]} e    [description]
     * @return {[type]}      [description]
     * @author jda
     */
    onDragLeaveNode(node, e) {
      const className = e.target.className;

      if (!isNil(className) && typeof className.replace === 'function') {
        e.target.className = className.replace('green', 'blue');
      }
    },
    /**
     * 화면에서 차트를 삭제한다.
     * @return {[type]} [description]
     * @author jda
     */
    onDeleteChart(chart) {
      const chartRscList = clone(this.chartRscList);
      const deleteChart = find(chartRscList, { chart });
      deleteChart.visible = false;
      remove(chartRscList, deleteChart);
      this.chartRscList = chartRscList;
      this.$emit('setChartList', chartRscList);
    },
    /**
     * 한 차트에서 실시간 성능 정보 조회를 하고 있으면 나머지 차트는 disabled
     * @author jda
     */
    setRealtimeChart(chart, flag) {
      const chartRscList = clone(this.chartRscList);
      chartRscList.forEach((chartInfo) => {
        if (chartInfo.chart !== chart) {
          chartInfo.realtimeFlag = !flag;
        }
      });
      this.chartRscList = chartRscList;
    },
    /**
     * 차트의 스타일을 반환한다.
     * @author Ju
     * @param  {Number} index 차트 배열에서 해당 차트의 index
     * @return {String, Object}       차트의 스타일
     */
    getCommonChartStyle(index) {
      let style = 'height:360px !important;';

      if (this.dropzoneVisible) {
        style += 'margin-left: 0; margin-right: 0;';
      } else if (index < this.chartRscList.length - 1) {
        style += 'margin-bottom:40px;';
      }

      return style;
    },
  },
};
</script>

<style scoped>
  .dropzone-area {
    min-height: 60px;
    margin-bottom: 8px;
  }

  .skcc-dropzone {
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/chart/components/view/customize/SkccChartDropZoneView.vue